import React from "react";
import { Button, Typography, CircularProgress, Box } from "@mui/material";
import Modal from "../layout/Modal";

const ConfirmationModal = ({
  show,
  handleClose,
  handleConfirm,
  title,
  body,
  buttonLabel,
  buttonLabelSecondary,
  buttonStyle,
  loading,
  hideButton = false,
  width,
}) => {
  const confirmLabel = buttonLabel || "Confirm";
  const cancelLabel = buttonLabelSecondary || "Cancel";
  const confirmColor = buttonStyle || "error";

  const renderBody = () => {
    const fallback = "Are you sure you want to proceed?";
    if (!body) return <Typography variant="body2">{fallback}</Typography>;
    if (typeof body === "string") return <Typography variant="body2">{body}</Typography>;
    return body;
  };

  const renderActions = () => {
    if (hideButton) return null;

    return () => (
      <>
        <Button
          variant="outlined"
          color="secondary"
          onClick={handleClose}
          disabled={loading}
          title={cancelLabel}
        >
          {cancelLabel}
        </Button>

        <Button
          color={confirmColor}
          variant="contained"
          onClick={handleConfirm}
          disabled={loading}
          title={confirmLabel}
          startIcon={
            loading ? (
              <CircularProgress size={16} color="inherit" />
            ) : null
          }
        >
          {confirmLabel}
        </Button>
      </>
    );
  };

  return (
    <Modal
      open={show}
      width={width || "sm"}
      handleClose={() => {
        if (!loading) handleClose();
      }}
      modalTitle={title || "Confirm"}
      action={renderActions()}
    >
      <Box sx={{ minHeight: 80, display: "flex", alignItems: "center" }}>
        {renderBody()}
      </Box>
    </Modal>
  );
};

export default ConfirmationModal;